import { render } from "./CodeDisplay.vue?vue&type=template&id=7164aa83"
import script from "./CodeDisplay.vue?vue&type=script&lang=js"
export * from "./CodeDisplay.vue?vue&type=script&lang=js"

import "./CodeDisplay.vue?vue&type=style&index=0&id=7164aa83&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__